import styled from "styled-components";

export const Container = styled.div``;

export const WrapperService = styled.div`
  margin-bottom: 20px;
`;
